<template lang="pug">
  div
    img(v-if="value.image" :src="value.image")
    span(v-else) {{ value.title }}
</template>

<script>
export default {
  name: 'answer',

  props: {
    value: null,
  },
};
</script>
